<div class="container-row rules-section">
  <h4>When the SOS button is pressed</h4>
</div>